import { apiInterfaceForJson } from '../common/apiManager';

// Get ALL patient medications across all patients (admin view)
export const getAllPatientMedications = (includeInactive = false) => {
    return apiInterfaceForJson(`/patientMedication/v1/?includeInactive=${includeInactive}`, 'GET');
};

// Get all patient medications
export const getPatientMedications = (patientId) => {
    return apiInterfaceForJson(`/patientMedication/v1/patient/${patientId}`, 'GET');
};

// Get patient medication by ID
export const getPatientMedicationById = (id) => {
    return apiInterfaceForJson(`/patientMedication/v1/${id}`, 'GET');
};

// Get patient medication history
export const getPatientMedicationHistory = (patientId, params) => {
    return apiInterfaceForJson(`/patientMedication/v1/patient/${patientId}/history`, 'GET', params);
};

// Add patient medication
export const addPatientMedication = (data) => {
    return apiInterfaceForJson('/patientMedication/v1/', 'POST', data);
};

// Update patient medication
export const updatePatientMedication = (id, data) => {
    return apiInterfaceForJson(`/patientMedication/v1/${id}`, 'PUT', data);
};

// Verify patient medication
export const verifyPatientMedication = (id, data) => {
    return apiInterfaceForJson(`/patientMedication/v1/${id}/verify`, 'POST', data);
};

// Discontinue patient medication
export const discontinuePatientMedication = (id, data) => {
    return apiInterfaceForJson(`/patientMedication/v1/${id}/discontinue`, 'POST', data);
};

// Toggle suspend patient medication
export const toggleSuspendPatientMedication = (id, data) => {
    return apiInterfaceForJson(`/patientMedication/v1/${id}/suspend`, 'PATCH', data);
};

// Update last dose time
export const updateLastDoseTime = (id, data) => {
    return apiInterfaceForJson(`/patientMedication/v1/${id}/last-dose`, 'PATCH', data);
};

// Record missed dose
export const recordMissedDose = (id, data) => {
    return apiInterfaceForJson(`/patientMedication/v1/${id}/missed-dose`, 'POST', data);
};

// Get summary for order
export const getMedicationSummaryForOrder = (orderId) => {
    return apiInterfaceForJson(`/patientMedication/v1/order/${orderId}/summary`, 'GET');
};

// Get medication warnings
export const getMedicationWarnings = (patientId, testId) => {
    return apiInterfaceForJson('/patientMedication/v1/warnings', 'POST', { patientId, testId });
};

// Get all medications (master list)
export const getAllMedications = () => {
    return apiInterfaceForJson('/medication/v1/', 'GET');
};

// Archive (soft-delete) a patient medication
export const deletePatientMedication = (id) => {
    return apiInterfaceForJson(`/patientMedication/v1/${id}`, 'DELETE');
};
